import * as React from 'react';

export interface ITechProps {
}

export function Tech(props: ITechProps) {
    return (
        <section className="tech-section">
            <div className="tech-container">
                <h2 className="tech-title">Technologies</h2>
                <div className="tech-grid">
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/java.svg' alt='Java'/></div>
                    </div>
                    <div className="icon-box">
                        <div><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/springboot.png' alt='Spring'/></div>
                    </div>
                    <div className="icon-box">
                        <div><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/kubernetes.svg' alt='Kubernetes'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/docker.svg' alt='Docker'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/git.svg' alt='git'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/react.svg' alt='react'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/CSS3.svg' alt='css'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/html.svg' alt='html'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/bootstrap.svg' alt='bootstrap'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/jenkins.svg' alt='jenkins'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/microsoft_azure.svg' alt='azure'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/aws.svg' alt='aws'/></div>
                    </div>
                    <div className="icon-box">
                        <div className="icon"><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/Kafka.svg' alt='kafka'/></div>
                    </div>
                    <div className="icon-box">
                        <div className="icon"><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/jira.svg' alt='jira'/></div>
                    </div>
                    <div className="icon-box">
                        <div className="icon"><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/confluence.svg' alt='confluence'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/android.svg' alt='android'/></div>
                    </div>
                    <div className="icon-box">
                        <div className="icon"><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/Splunk.svg' alt='splumk'/></div>
                    </div>
                    <div className="icon-box">
                        <div className="icon"><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/grafana.svg' alt='grafana'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/argocd.svg' alt='argocd'/></div>
                    </div>
                    <div className="icon-box">
                        <div className="icon"><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/firebase.svg' alt='firebase'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/mysql-new.svg' alt='mysql'/></div>
                    </div>
                    <div className="icon-box">
                        <div ><img src='https://vishnumohandaspersonalsa.blob.core.windows.net/static/postgresql.svg' alt='postgresql'/></div>
                    </div>
                </div>
            </div>
        </section>
    );
}
